// extracted by mini-css-extract-plugin
module.exports = {"trash":"trash___39Zju","spinner":"spinner___2Mak8"};